import { kcal } from '../lib/format';

interface RingProps {
  eaten: number;
  goal: number;
  size?: number;
  stroke?: number;
}

/** Calorie budget ring: the arc fills as you eat; the center shows what's left. */
export function Ring({ eaten, goal, size = 148, stroke = 14 }: RingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = goal > 0 ? Math.min(1, eaten / goal) : 0;
  const left = goal - eaten;
  const over = left < 0;
  return (
    <div
      className={`ring ${over ? 'is-over' : ''}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={`${kcal(Math.abs(left))} calories ${over ? 'over' : 'left'} of ${kcal(goal)}`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle className="ring__track" cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} />
        <circle
          className="ring__fill"
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="ring__center">
        <div className="ring__big num">{kcal(Math.abs(left))}</div>
        <div className="ring__label">{over ? 'kcal over' : 'kcal left'}</div>
      </div>
    </div>
  );
}
